import { render, staticRenderFns } from "./ReferralEdit.vue?vue&type=template&id=9a21b810"
import script from "./ReferralEdit.vue?vue&type=script&lang=js"
export * from "./ReferralEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports